import { ModuleContent } from '../contract';

export type HtmlCodeModuleContent = { htmlCode: string };
export type SharedCssModuleContent = { sharedCss: string };

export function getHtmlCodeIndexableText(content: ModuleContent): string {
	return typeof content.htmlCode === 'string' ? content.htmlCode.replace(/<[^>]*>/g, ' ').trim() : '';
}
